var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.05546 2.05546C4.57118 1.53973 5.27065 1.25 6 1.25H14C14.1989 1.25 14.3897 1.32902 14.5303 1.46967L20.5303 7.46967C20.671 7.61032 20.75 7.80109 20.75 8V20C20.75 20.7293 20.4603 21.4288 19.9445 21.9445C19.4288 22.4603 18.7293 22.75 18 22.75H6C5.27065 22.75 4.57118 22.4603 4.05546 21.9445C3.53973 21.4288 3.25 20.7293 3.25 20V4C3.25 3.27065 3.53973 2.57118 4.05546 2.05546ZM6 2.75C5.66848 2.75 5.35054 2.8817 5.11612 3.11612C4.8817 3.35054 4.75 3.66848 4.75 4V20C4.75 20.3315 4.8817 20.6495 5.11612 20.8839C5.35054 21.1183 5.66848 21.25 6 21.25H18C18.3315 21.25 18.6495 21.1183 18.8839 20.8839C19.1183 20.6495 19.25 20.3315 19.25 20V8.75H14C13.5858 8.75 13.25 8.41421 13.25 8V2.75H6ZM14.75 3.81066L18.1893 7.25H14.75V3.81066ZM7.25 9C7.25 8.58579 7.58579 8.25 8 8.25H10C10.4142 8.25 10.75 8.58579 10.75 9C10.75 9.41421 10.4142 9.75 10 9.75H8C7.58579 9.75 7.25 9.41421 7.25 9ZM7.25 13C7.25 12.5858 7.58579 12.25 8 12.25H16C16.4142 12.25 16.75 12.5858 16.75 13C16.75 13.4142 16.4142 13.75 16 13.75H8C7.58579 13.75 7.25 13.4142 7.25 13ZM7.25 17C7.25 16.5858 7.58579 16.25 8 16.25H16C16.4142 16.25 16.75 16.5858 16.75 17C16.75 17.4142 16.4142 17.75 16 17.75H8C7.58579 17.75 7.25 17.4142 7.25 17Z",
    fill: "#82868E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.1e30295d5f8d7c93a5957f1374fee43e.svg";
export { ForwardRef as ReactComponent };